import { _, React, classNames, withStyles, StyledProps } from '@api'
import { ListItem, ListItemText, ListItemSecondaryAction, Checkbox, Theme } from '@material-ui/core'
import { TextInput, Collapsible } from 'centric-ui-components'

const styles = (theme: Theme) => ({
  label:    {
    fontSize: 14,
    color:    'rgba(27, 27, 27, 0.87)'
  },
  listItem: {
    height:    48,
    listStyle: 'none',
    margin:    '0 -16px 0 0'
  },
  text:     {
    marginBottom:   theme.spacing(),
    height:         56,
    '&:last-child': {
      marginBottom: theme.spacing() * 4
    }
  },
  checkbox: {
    width:       24,
    height:      24,
    marginRight: theme.spacing(),
    '& svg':     {
      width:  18,
      height: 18
    }
  }
})

interface MyProps extends StyledProps {
  open?: boolean
  handleChange: (e, v) => void
  data?: any
  onChangeInput: (e, v) => void,
  onClickCollapseHeader: (e, v) => void,
  onBlurAttribute: (e, v) => void
  loading?: boolean
}

export class ProductAttributesComponent extends React.Component<MyProps> {
  static defaultProps = {
    handleChange:          () => {},
    onChangeInput:         () => {},
    onClickCollapseHeader: () => {},
    onBlurAttribute:       () => {},
    data:                  {
      attributes: {}
    }
  }

  render() {
    const {open, data, classes, handleChange, onChangeInput, onClickCollapseHeader, onBlurAttribute, loading} = this.props
    return (
      <Collapsible open={open} title={'Attributes'} handleClick={(e) => { onClickCollapseHeader(e, 'productAttributes') }}>
        <ListItem disableGutters classes={{container: classes.listItem}}>
          <ListItemText classes={{primary: classes.label}} primary={'Carryover'}/>
          <ListItemSecondaryAction>
            <Checkbox
              classes={{root: classNames(classes.checkbox, {skeleton: loading})}}
              onChange={(e) => { handleChange(e.target, 'carryover') }}
              checked={data.attributes && data.attributes.carryover ? data.attributes.carryover.value : false}
            />
          </ListItemSecondaryAction>
        </ListItem>
        <TextInput
          name={'sample'}
          loading={loading}
          data-id='samples'
          label={'Samples'}
          fullWidth
          value={(data.attributes && data.attributes.sample && data.attributes.sample.value) || ''}
          placeholder={`Enter Samples`}
          onChange={(e) => { onChangeInput(e.target, 'sample') }}
          onBlur={(e) => {onBlurAttribute(e.target, 'sample')}}
        />
        <TextInput
          name={'price'}
          label={'Target Price'}
          loading={loading}
          fullWidth
          value={(data.attributes && data.attributes.targetPrice && data.attributes.targetPrice.value) || ''}
          data-id='target-price'
          placeholder={`Enter Target Price`}
          onChange={(e) => { onChangeInput(e.target, 'targetPrice') }}
          onBlur={(e) => {onBlurAttribute(e.target, 'targetPrice')}}
        />
        <TextInput
          name={'quantity'}
          label={'Target Quantity'}
          loading={loading}
          fullWidth
          className={classes.text}
          value={(data.attributes && data.attributes.targetQuantity && data.attributes.targetQuantity.value) || ''}
          data-id='target-quantity'
          placeholder={`Enter Target Quantity`}
          onChange={(e) => { onChangeInput(e.target, 'targetQuantity') }}
          onBlur={(e) => {onBlurAttribute(e.target, 'targetQuantity')}}
        />
      </Collapsible>
    )
  }
}

@(withStyles as any)(styles)
export class ProductAttributes extends ProductAttributesComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/ProductAttributes.tsx